import { useGiveawayTimer } from 'root/src/client/v2/giveaways/hooks/useGiveawayTimer';
import { useGiveawaySection } from 'root/src/client/web/giveaway/features/GiveawaySection/hooks/useGiveawaySection';
import { PickingWinner } from 'root/src/client/web/giveaway/features/GiveawaySection/PickingWinner';
import { memo, useEffect } from 'react';
import { twMerge } from 'tailwind-merge';
import { TimeLeftCountdown } from 'root/src/client/web/giveaway/features/GiveawaySection/TimeLeftCountdown';
import { useCreatorDataApi } from 'root/src/client/logic/api/hooks/useCreatorDataApi';
import { useGiveawayApi } from 'root/src/client/web/giveaway/hooks/useGiveawayApi';
import { VoucherStatus } from '@daredrop-com/rewards-api-contract';
const WaitingForParticipants = memo(({ participantsNeeded, timeLeftParts, timeLeft }) => {
    const isUrgent = timeLeft < (5 * 60 * 1000); // 5 minutes in milliseconds
    return (<div className="flex flex-col items-center gap-2">
			<span className="text-light-4 uppercase text-xs">Waiting for participants</span>
			<div className={twMerge('text-2xl font-bold font-mono text-center', isUrgent ? 'text-pink animate-pulse' : 'text-teal')}>
				{participantsNeeded} more needed
			</div>
			<div className="flex items-center gap-1 text-light-4 text-sm">
				<span>within</span>
				<span className="font-mono font-bold text-white">
					<TimeLeftCountdown {...timeLeftParts}/>
				</span>
			</div>
		</div>);
});
export const GiveawayTimer = memo(() => {
    const creatorDataApi = useCreatorDataApi();
    const giveawayApi = useGiveawayApi();
    const { classes, giveaway } = useGiveawaySection();
    const { isPickingWinner, timeLeftParts, timeLeft, isWaitingForParticipants, participantsNeeded, interval, } = useGiveawayTimer(giveaway);
    useEffect(() => {
        return () => {
            interval.clear();
            void creatorDataApi.fetchGiveaways();
            void creatorDataApi.fetchScheduler();
            void giveawayApi.fetchVouchers(VoucherStatus.Available);
        };
    }, []);
    if (isPickingWinner) {
        return <PickingWinner />;
    }
    if (isWaitingForParticipants) {
        return (<WaitingForParticipants participantsNeeded={participantsNeeded} timeLeftParts={timeLeftParts} timeLeft={timeLeft}/>);
    }
    const isAlerting = timeLeft < (20 * 1000); // 20 seconds in milliseconds
    return (<div className={classes.activeGiveawayInfo}>
			<span className={classes.timeRemainingLabel}>Giveaway time remaining</span>
			<div className={twMerge(classes.timeRemaining, isAlerting && 'animate-pulse !text-pink select-none')}>
				<TimeLeftCountdown {...timeLeftParts}/>
			</div>
		</div>);
});
